var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullBox"},[_c('div',{staticClass:"fullBox"},[_c('router-view',{staticClass:"fullBox"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }